import { Lightning } from '@lightningjs/sdk';
import { Theme } from '../../config/theme';
import { CmsConstants } from '../../Business/cms/CmsConstants';

export class CmsBorder extends Lightning.Component {
  static _template() {
    const dims = CmsConstants.Card;
    return {
      x: 0,
      y: 0,
      w: w => w,
      h: h => h,
      Outer: {
        flexItem: false,
        x: 0,
        y: 0,
        w: w => w,
        h: h => h,
        rect: true,
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: dims.outerRadius,
          stroke: dims.borderSize,
          strokeColor: Theme.Colors.Primary,
          fillColor: Theme.Colors.Transparent,
        },
      },
      Inner: {
        x: dims.innerOffset,
        y: dims.innerOffset,
        w: w => w - dims.innerOffset - dims.innerOffset,
        h: h => h - dims.innerOffset - dims.innerOffset,
        rect: true,
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: dims.innerRadius,
          stroke: dims.borderSize,
          strokeColor: Theme.Colors.Ribbon.Card.Unfocus,
          fillColor: Theme.Colors.Transparent,
        },
      },
    };
  }
}
